var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row", attrs: { id: "top" } }, [
          _c(
            "div",
            { staticClass: "col text-center" },
            [
              _c("router-link", { staticClass: "logo", attrs: { to: "/" } }, [
                _c("img", {
                  attrs: { src: "/images/logo.png", alt: "De Duursportcoach" }
                })
              ])
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "pt-5", attrs: { role: "main" } }, [
      _c("section", { attrs: { id: "error" } }, [
        _c("div", { staticClass: "container-wrapper-white" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col pt-5 pb-5" }, [
                _c("h1", { staticClass: "text-blue" }, [
                  _vm._v("Pagina niet gevonden")
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-blue" },
                  [
                    _vm._v(
                      "\n                                Klik hier om naar de\n                                "
                    ),
                    _c(
                      "router-link",
                      { staticClass: "text-blue", attrs: { to: "/" } },
                      [_vm._v("homepage")]
                    ),
                    _vm._v(
                      "\n                                te gaan.\n                            "
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }